import type { CountryTax } from '../../types/tax'

export const countryTaxSystems: CountryTax[] = [
  {
    timezone: ['Australia/*'],
    taxSystem: {
      country: 'Australia',
      countryCode: 'AU',
      name: 'GST',
      abbreviation: 'GST',
      defaultRate: 10
    }
  },
  {
    timezone: ['Pacific/Auckland', 'Pacific/Chatham'],
    taxSystem: {
      country: 'New Zealand',
      countryCode: 'NZ',
      name: 'GST',
      abbreviation: 'GST',
      defaultRate: 15
    }
  },
  {
    timezone: ['Europe/London'],
    taxSystem: {
      country: 'United Kingdom',
      countryCode: 'UK',
      name: 'VAT',
      abbreviation: 'VAT',
      defaultRate: 20
    }
  },
  {
    timezone: ['Europe/*'],
    taxSystem: {
      country: 'European Union',
      countryCode: 'EU',
      name: 'VAT',
      abbreviation: 'VAT',
      defaultRate: 21
    }
  },
  {
    timezone: ['America/Toronto', 'America/Vancouver', 'America/Halifax'],
    taxSystem: {
      country: 'Canada',
      countryCode: 'CA',
      name: 'GST',
      abbreviation: 'GST',
      defaultRate: 5
    }
  },
  {
    timezone: [
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Los_Angeles'
    ],
    taxSystem: {
      country: 'United States',
      countryCode: 'US',
      name: 'Sales Tax',
      abbreviation: 'Sales Tax',
      defaultRate: 10
    }
  }
]
